import React from 'react';
import { useSelector } from 'react-redux';


// use in main layout
const LoadingSpinner = () => {

  const headerAnimation=(
    <div className="flex flex-row justify-center items-center space-x-2 w-1/3 h-1/3 fixed">

      <div className="nav-icon text-2xl flex items-end  gap-[2px] md:gap-[4px] justify-center w-96 md:h-36 h-20 space-x-0.5 relative">
        {[
          { height: '60%', delay: '-0.4s', bg: 'from-gray-800 to-blue-950' },
          { height: '75%', delay: '-0.2s', bg: 'from-gray-700 to-blue-950' },
          { height: '80%', delay: '0s',    bg: 'from-gray-800 to-blue-950' },
          { height: '60%', delay: '0.2s',    bg: 'from-blue-950 to-gray-800' },
          
        ].map((bar, idx) => (
          <div
            key={idx}
            className={`md:w-[18px] w-[10px] rounded-lg animate-candle bg-gradient-to-t ${bar.bg}`}
            style={{
              height: bar.height,
              animationDelay: bar.delay,
            }}
          />
        ))}
      </div>
      {/* <h1 className="text-2xl font-bold text-text-primary">Markets</h1> */}
    </div>
  )

 const Flag=useSelector((state)=>state.loading.global)
 
  return (
    <>
    {
     
     Flag &&
  
           <div
      dir="rtl"
      className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-50"
    >
           {headerAnimation}
    </div>
      

    }
    </>
  );
};

export default LoadingSpinner;